<!-- 系统列表 -->
<template>
  <div class="app-container">
    <div ref="appContentLayoutRef" class="app-content">
      <!-- 头部概览数据 -->
      <div v-if="!isJinXiangHuaShengUser" class="top-view" :style="{ height: styles.topViewHeight }">
        <el-card>
          <template slot="header">
            <img src="../../assets/icon/power_icon.png" alt="">
            {{ $t('text.fdgl') }}
          </template>
          <template slot="default">
            <div v-loading="overviewLoading" class="container" element-loading-background="rgba(28, 37, 80, 0.8)">
              <div id="powerChart" />
            </div>
          </template>
        </el-card>
        <el-card>
          <template slot="header">
            <img src="../../assets/icon/online_icon.png" alt="">
            {{ $t('text.cjqsl') }}
          </template>
          <template slot="default">
            <div v-loading="overviewLoading" class="container" element-loading-background="rgba(28, 37, 80, 0.8)">
              <div id="gatewayChart" />
            </div>
          </template>
        </el-card>
        <el-card>
          <template slot="header">
            <img src="../../assets/icon/total_icon.png" alt="">
            {{ $t('text.zfdl') }}
          </template>
          <template slot="default">
            <div v-loading="overviewLoading" class="container" element-loading-background="rgba(28, 37, 80, 0.8)">
              <div id="totalEnergyChart" />
            </div>
          </template>
        </el-card>
        <el-card>
          <template slot="header">
            <img src="../../assets/icon/income_icon.png" alt="" style="height: 18px;">
            {{ $t('text.stationCount') }}
          </template>
          <template slot="default">
            <div v-loading="overviewLoading" class="container" element-loading-background="rgba(28, 37, 80, 0.8)">
              <div id="stationChart" />
            </div>
          </template>
        </el-card>
      </div>

      <!-- 查询条件 -->
      <div class="filter-container" :style="{ height: styles.filterHeight }">
        <el-form inline size="small" @submit.native.prevent>
          <el-form-item :label="$t('text.dzmc')">
            <el-input
              v-model="pageConfig.queryParams.orgname"
              clearable
              @keyup.enter.native="handleQuery"
            />
          </el-form-item>
          <el-form-item v-if="!isJinXiangHuaShengUser" :label="$t('text.dzlx')">
            <el-select v-model="pageConfig.queryParams.orgtype" placeholder="" clearable>
              <el-option
                v-for="item in Object.keys(orgTypeOptions)"
                :key="item"
                :value="item"
                :label="orgTypeOptions[item]"
              />
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('bghn.dzzt')">
            <el-select v-model="pageConfig.queryParams.status" placeholder="" clearable>
              <el-option
                v-for="item in orgStatusOptions"
                :key="item.value"
                :value="item.value"
                :label="item.key"
              />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              icon="el-icon-search"
              :loading="pageConfig.loading || overviewLoading"
              @click="handleQuery"
            >{{ $t('button.cx') }}</el-button>
          </el-form-item>
        </el-form>
      </div>

      <!-- 表格 -->
      <div class="table-container" :style="{ height: `calc(100% - ${styles.topViewHeight} - ${styles.filterHeight})` }">
        <el-table v-loading="pageConfig.loading || overviewLoading" height="calc(100% - 50px)" :data="pageConfig.tableData" element-loading-background="rgba(28, 37, 80, 0.8)">
          <template slot="empty">
            <div class="table-no-data" />
          </template>
          <el-table-column align="center" :label="$t('text.zt')" width="100">
            <template v-slot="scope">
              <i class="fa-circle fa" :style="{ color: orgStatusColor[scope.row.status] || colors.offlineColor }" />
            </template>
          </el-table-column>
          <el-table-column :label="$t('text.dzmc')" show-overflow-tooltip>
            <template v-slot="scope">
              <span class="pointer" @click="goStation(scope.row)">{{ scope.row.orgname }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="orgtype" align="center" :label="$t('text.zdlx')" :formatter="orgTypeFormatter" width="100" show-overflow-tooltip />
          <template v-if="!isJinXiangHuaShengUser">
            <el-table-column align="center" :label="$t('text.dqgl')" width="155" show-overflow-tooltip>
              <template v-slot="scope">
                <span>{{ scope.row.power | unit('kW') }}</span>
              </template>
            </el-table-column>
            <el-table-column align="center" :label="$t('text.drfdl')" width="155" show-overflow-tooltip>
              <template v-slot="scope">
                <span>{{ scope.row.fetoday }}</span>
              </template>
            </el-table-column>
            <el-table-column align="center" :label="$t('text.ljfdl')" width="155" show-overflow-tooltip>
              <template v-slot="scope">
                <span>{{ scope.row.fetotal }}</span>
              </template>
            </el-table-column>
          </template>
          <el-table-column prop="stationProvincialAddress" align="center" label="电站省份/直辖市" width="155" show-overflow-tooltip />
          <el-table-column v-if="!isJinXiangHuaShengUser" prop="meterStationGatewayTimeShare" align="center" label="电表使用费率" width="200" show-overflow-tooltip />
          <el-table-column prop="createtime" align="center" :label="$t('text.cjsj')" :formatter="orgCreateTimeFormatter" width="155" show-overflow-tooltip />
          <el-table-column align="center" :label="$t('text.cz')" width="155">
            <template v-slot="scope">
              <el-button
                size="small"
                type="text"
                class="danger"
                icon="el-icon-delete"
                @click="handleDelete(scope.row)"
              >{{ $t('button.sc') }}</el-button>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页组件 -->
        <pagination
          v-show="!pageConfig.loading && pageConfig.total>0"
          :total="pageConfig.total"
          :page.sync="pageConfig.pageNum"
          :limit.sync="pageConfig.pageSize"
          :page-sizes="pageConfig.pageSizes"
          :layout="pageConfig.layout"
          :style="{ height: styles.paginationHeight, backgroundColor: '#1A4A6E' }"
          @pagination="getTableData"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { QueryStations, DeleteStation } from '@apis/Stations'
import { GetManagerOverviewData } from '@apis/Statistics'
import { getEchart } from '@/utils/echarts'
import dayjs from 'dayjs'
import colorConfig from '@/styles/variable.module.css'
export default {
  components: {
  },
  data () {
    return {

      /** 颜色配置 */
      colors: colorConfig,

      /** 分页配置项 */
      pageConfig: {
        loading: false,
        pageType: 'list',
        total: 0,
        pageNum: 1,
        pageSize: 10,
        queryParams: {},
        tableData: [],
        layout: 'total, prev, pager, next, jumper',
      },

      /** 概览数据 */
      overviewData: {
        /** 采集器状态统计 */
        gatewaysCnt: {
          /** 在线数 */
          onlines: 0,
          /** 离线数 */
          offlines: 0,
          /** 报警数 */
          alarms: 0,
          /** 已安装数 */
          installeds: 0,
          /** 总数 */
          totals: 0,
        },
      },

      /** 概览数据加载中 */
      overviewLoading: false,

      /** 电站类型选项 */
      orgTypeOptions: {
        '0': '组串',
        '1': '储能',
        '2': '气象',
        '3': '电表',
        '4': '开关',
      },

      /** 电站状态选项 */
      orgStatusOptions: [
        { key: '正常', value: '0' },
        { key: '部分离线', value: '1' },
        { key: '离线', value: '2' },
        { key: '报警', value: '3' },
      ],

      /** 电站状态颜色映射 */
      orgStatusColor: {
        '0': colorConfig.onlineColor,
        '1': colorConfig.partOnlineColor,
        '2': colorConfig.offlineColor,
        '3': colorConfig.alarmColor,
      },

      /** 顶部图表配置项 */
      topChartOption: {
        /** 功率图表 */
        powerChart: {
          grid: {
            top: 5,
            bottom: 5,
          },
          series: [
            {
              name: 'outer',
              type: 'gauge',
              radius: '100%',
              axisLine: {
                lineStyle: {
                  color: [[1, '#1FD09D']],
                  width: 10
                }
              },
              axisLabel: {
                show: false
              },
              axisTick: {
                show: false
              },
              splitLine: {
                show: false
              },
              progress: {
                show: false
              },
              pointer: {
                show: false
              },
              detail: {
                show: false
              },
              title: {
                show: false
              },
              data: [
                {
                  value: 0,
                  name: 'outer'
                }
              ]
            },
            {
              name: 'inner',
              type: 'gauge',
              title: {
                offsetCenter: [0, 15],
                color: '#B6801F',
                fontSize: 12,
                fontWeight: 'bold'
              },
              detail: {
                offsetCenter: [0, -5],
                color: '#B6801F',
                fontSize: 20,
                fontWeight: 'bold'
              },
              data: [{ value: 0, name: 'inner' }],
              pointer: {
                show: false
              },
              axisLabel: {
                show: false
              },
              axisTick: {
                show: false
              },
              splitNumber: 8,
              splitLine: {
                lineStyle: {
                  color: '#1D3666',
                  width: 5
                }
              },
              axisLine: {
                show: true,
                lineStyle: {
                  color: [[1, '#1FD09D']],
                  width: 15
                }
              }
            }
          ]
        },
        /** 采集器图表 */
        gatewayChart: {
          color: [colorConfig.isRuningColor, colorConfig.unRuningColor, colorConfig.onlineColor, colorConfig.partOnlineColor, colorConfig.offlineColor, colorConfig.alarmColor],
          legend: {
            data: [
              {
                icon: 'circle',
                name: '已使用',
                textStyle: {
                  color: colorConfig.isRuningColor
                }
              },
              {
                icon: 'circle',
                name: '未使用',
                textStyle: {
                  color: colorConfig.unRuningColor
                }
              },
              {
                icon: 'circle',
                name: '在线',
                textStyle: {
                  color: colorConfig.onlineColor
                }
              },
              {
                icon: 'circle',
                name: '部分离线',
                textStyle: {
                  color: colorConfig.partOnlineColor
                }
              },
              {
                icon: 'circle',
                name: '离线',
                textStyle: {
                  color: colorConfig.offlineColor
                }
              },
              {
                icon: 'circle',
                name: '报警',
                textStyle: {
                  color: colorConfig.alarmColor
                }
              }
            ],
            orient: 'vertical',
            right: 50,
            top: 'center'
          },
          series: [
            {
              name: 'outer',
              type: 'pie',
              hoverAnimation: false,
              center: ['30%', '50%'],
              radius: ['75%', '90%'],
              label: {
                show: false
              },
              data: [
                { value: 0, name: '已使用', emphasis: { itemStyle: { color: colorConfig.isRuningColor }}},
                { value: 0, name: '未使用', emphasis: { itemStyle: { color: colorConfig.unRuningColor }}}
              ]
            },
            {
              name: 'inner',
              type: 'pie',
              hoverAnimation: false,
              center: ['30%', '50%'],
              radius: ['55%', '70%'],
              label: {
                show: false,
              },
              data: [
                { value: 0, name: '在线', emphasis: { itemStyle: { color: colorConfig.onlineColor }}},
                { value: 0, name: '部分离线', emphasis: { itemStyle: { color: colorConfig.partOnlineColor }}},
                { value: 0, name: '离线', emphasis: { itemStyle: { color: colorConfig.offlineColor }}},
                { value: 0, name: '报警', emphasis: { itemStyle: { color: colorConfig.alarmColor }}}
              ]
            }
          ],
          graphic: {
            elements: [
              {
                type: 'text',
                style: {
                  text: '0',
                  fontSize: 20,
                  fill: '#B6801F',
                  fontWeight: 'bold',
                  textAlign: 'center'
                },
                top: 80,
                left: 100
              },
              {
                type: 'text',
                style: {
                  text: '采集器总数',
                  fontSize: 12,
                  fill: '#B6801F',
                  fontWeight: 'bold'
                },
                top: 105,
                left: 100
              }
            ]
          }
        },
        /** 总能量图表 */
        totalEnergyChart: {
          grid: {
            top: 5,
            bottom: 5,
          },
          series: [
            {
              name: 'outer',
              type: 'gauge',
              radius: '95%',
              startAngle: 0,
              endAngle: 359.999999,
              detail: {
                show: false
              },
              title: {
                show: false
              },
              data: [{ value: 0, name: 'outer' }],
              pointer: {
                show: false
              },
              axisLine: {
                show: false
              },
              axisTick: {
                show: false
              },
              axisLabel: {
                show: false
              },
              splitNumber: 50,
              splitLine: {
                length: 8,
                lineStyle: {
                  color: '#1FD09D',
                }
              }
            },
            {
              name: 'inner',
              type: 'gauge',
              radius: '80%',
              startAngle: 0,
              endAngle: -359.999999,
              detail: {
                offsetCenter: [0, -5],
                color: '#B6801F',
                fontWeight: 'bold',
                fontSize: 20,
              },
              title: {
                offsetCenter: [0, 15],
                color: '#B6801F',
                fontWeight: 'bold',
                fontSize: 12,
              },
              data: [{ value: 0, name: 'inner' }],
              pointer: {
                show: false
              },
              axisLine: {
                show: true,
                lineStyle: {
                  color: [[1, '#1FD09D']],
                  width: 10
                }
              },
              axisLabel: {
                show: false
              },
              axisTick: {
                show: false
              },
              splitLine: {
                show: false
              }
            }
          ]
        },
        /** 电站图表 */
        stationsChart: {
          color: [colorConfig.onlineColor, colorConfig.partOnlineColor, colorConfig.offlineColor, colorConfig.alarmColor],
          legend: {
            data: [
              {
                icon: 'circle',
                name: '正常',
                textStyle: {
                  color: colorConfig.onlineColor
                }
              },
              {
                icon: 'circle',
                name: '部分在线',
                textStyle: {
                  color: colorConfig.partOnlineColor
                }
              },
              {
                icon: 'circle',
                name: '离线',
                textStyle: {
                  color: colorConfig.offlineColor
                }
              },
              {
                icon: 'circle',
                name: '报警',
                textStyle: {
                  color: colorConfig.alarmColor
                }
              }
            ],
            orient: 'vertical',
            right: 50,
            top: 'center'
          },
          series: [
            {
              name: '电站状态',
              type: 'pie',
              center: ['30%', '50%'],
              radius: ['70%', '90%'],
              avoidLabelOverlap: false,
              hoverOffset: 0,
              label: { show: false },
              labelLine: { show: false },
              data: [
                { value: 0, name: '正常', emphasis: { itemStyle: { color: '#67C23A' }}},
                { value: 0, name: '部分在线', emphasis: { itemStyle: { color: '#E6A23C' }}},
                { value: 0, name: '离线', emphasis: { itemStyle: { color: '#909399' }}},
                { value: 0, name: '报警', emphasis: { itemStyle: { color: '#F56C6C' }}},
              ]
            }
          ],
          graphic: {
            elements: [
              {
                type: 'text',
                style: {
                  text: '100',
                  fontSize: 20,
                  fontWeight: 'bold',
                  fill: '#B6801F'
                },
                top: 80,
                left: 100
              },
              {
                type: 'text',
                style: {
                  text: '电站总数',
                  fontSize: 12,
                  fontWeight: 'bold',
                  fill: '#B6801F'
                },
                top: 105,
                left: 100
              }
            ]
          }
        },
      },

      /** 样式 */
      styles: {
        topViewHeight: '240px',
        filterHeight: '60px',
        paginationHeight: '50px'
      }}
  },
  computed: {
    /**
     * 登录账号是否是金象华升账号
     */
    isJinXiangHuaShengUser: function () {
      return this.$store.getters.id === process.env.VUE_APP_JinXiangHuaSheng_Userid
    }
  },
  created () {
    this.setTopViewHeight()
  },
  mounted () {
    if (!this.isJinXiangHuaShengUser) {
      this.getOverviewData().then(() => {
        this.getTableData()
      })
    } else {
      this.getTableData()
    }
  },
  methods: {

    /** 设置顶部视图高度 */
    setTopViewHeight () {
      if (this.isJinXiangHuaShengUser) {
        this.styles.topViewHeight = '0px'
      }
    },

    /**
     * 电站类型格式化
     * @param _row
     * @param _column
     * @param cellValue
     * @param _index
     */
    orgTypeFormatter (_row, _column, cellValue, _index) {
      return this.orgTypeOptions[cellValue] || '--'
    },

    /**
     * 创建时间格式化
     * @param _row
     * @param _column
     * @param cellValue
     * @param _index
     */
    orgCreateTimeFormatter (_row, _column, cellValue, _index) {
      return cellValue ? dayjs(cellValue).format('YYYY-MM-DD HH:mm:ss') : '--'
    },

    /**
     * 获取概览数据
     */
    getOverviewData () {
      return new Promise((resolve, reject) => {
        this.overviewLoading = true
        GetManagerOverviewData().then(res => {
          this.overviewData = res.data
          const { power } = this.overviewData
          this.topChartOption.powerChart.series[1].data[0].value = Number(power.cvalue[0])
          this.topChartOption.powerChart.series[1].data[0].name = power.cvalue[1]
          getEchart(this.$echarts, 'powerChart', this.topChartOption.powerChart)
        }).then(() => {
          const { ymdEnergy } = this.overviewData
          this.topChartOption.totalEnergyChart.series[1].data[0].value = Number(ymdEnergy.totalEnergy.f.cvalue[0])
          this.topChartOption.totalEnergyChart.series[1].data[0].name = ymdEnergy.totalEnergy.f.cvalue[1]
          getEchart(this.$echarts, 'totalEnergyChart', this.topChartOption.totalEnergyChart)
        }).then(() => {
          const { gatewaysCnt } = this.overviewData
          const uninstalled = gatewaysCnt.totals - gatewaysCnt.installeds
          this.topChartOption.gatewayChart.series[0].data[0].value = gatewaysCnt.installeds
          this.topChartOption.gatewayChart.series[0].data[1].value = uninstalled
          this.topChartOption.gatewayChart.series[1].data[0].value = gatewaysCnt.onlines
          this.topChartOption.gatewayChart.series[1].data[1].value = gatewaysCnt.partOnlines
          this.topChartOption.gatewayChart.series[1].data[2].value = gatewaysCnt.offlines
          this.topChartOption.gatewayChart.series[1].data[3].value = gatewaysCnt.alarms

          this.topChartOption.gatewayChart.series[0].data[0].name = `已使用 ${gatewaysCnt.installeds}`
          this.topChartOption.gatewayChart.series[0].data[1].name = `未使用 ${uninstalled}`
          this.topChartOption.gatewayChart.series[1].data[0].name = `在线 ${gatewaysCnt.onlines}`
          this.topChartOption.gatewayChart.series[1].data[1].name = `部分离线 ${gatewaysCnt.partOnlines}`
          this.topChartOption.gatewayChart.series[1].data[2].name = `离线 ${gatewaysCnt.offlines}`
          this.topChartOption.gatewayChart.series[1].data[3].name = `报警 ${gatewaysCnt.alarms}`

          this.topChartOption.gatewayChart.legend.data[0].name = `已使用 ${gatewaysCnt.installeds}`
          this.topChartOption.gatewayChart.legend.data[1].name = `未使用 ${uninstalled}`
          this.topChartOption.gatewayChart.legend.data[2].name = `在线 ${gatewaysCnt.onlines}`
          this.topChartOption.gatewayChart.legend.data[3].name = `部分离线 ${gatewaysCnt.partOnlines}`
          this.topChartOption.gatewayChart.legend.data[4].name = `离线 ${gatewaysCnt.offlines}`
          this.topChartOption.gatewayChart.legend.data[5].name = `报警 ${gatewaysCnt.alarms}`

          this.topChartOption.gatewayChart.graphic.elements[0].style.text = gatewaysCnt.totals
          getEchart(this.$echarts, 'gatewayChart', this.topChartOption.gatewayChart)
        }).then(() => {
          const { stationsCnt } = this.overviewData
          this.topChartOption.stationsChart.series[0].data[0].value = stationsCnt.onlines
          this.topChartOption.stationsChart.series[0].data[1].value = stationsCnt.partOnlines
          this.topChartOption.stationsChart.series[0].data[2].value = stationsCnt.offlines
          this.topChartOption.stationsChart.series[0].data[3].value = stationsCnt.alarms

          this.topChartOption.stationsChart.series[0].data[0].name = `正常 ${stationsCnt.onlines}`
          this.topChartOption.stationsChart.series[0].data[1].name = `部分在线 ${stationsCnt.partOnlines}`
          this.topChartOption.stationsChart.series[0].data[2].name = `离线 ${stationsCnt.offlines}`
          this.topChartOption.stationsChart.series[0].data[3].name = `报警 ${stationsCnt.alarms}`

          this.topChartOption.stationsChart.legend.data[0].name = `正常 ${stationsCnt.onlines}`
          this.topChartOption.stationsChart.legend.data[1].name = `部分在线 ${stationsCnt.partOnlines}`
          this.topChartOption.stationsChart.legend.data[2].name = `离线 ${stationsCnt.offlines}`
          this.topChartOption.stationsChart.legend.data[3].name = `报警 ${stationsCnt.alarms}`

          this.topChartOption.stationsChart.graphic.elements[0].style.text = stationsCnt.totals
          getEchart(this.$echarts, 'stationChart', this.topChartOption.stationsChart)
        }).then(() => {
          this.overviewLoading = false
          resolve()
        }).catch(() => {
          this.overviewLoading = false
          reject()
        })
      })
    },

    /**
     * 电站跳转
     * @param item 电站数据
     */
    goStation (item) {
      this.$store.dispatch('station/setStationInfo', item)
      this.$store.dispatch('station/setStationControl', item.mr || 0)
      this.$store.dispatch('station/setStationGtypes', item.gtypes)
      const orgtypeUrl = {
        '0': 'series/home',
        '1': 'energy/home',
        '2': 'weather/home',
        '3': 'meter/home',
        '4': 'switch/home'
      }
      window.open(orgtypeUrl[item.orgtype])
    },

    /**
     * 获取表格数据
     */
    getTableData () {
      this.pageConfig.loading = true
      QueryStations({
        page: this.pageConfig.pageNum,
        perPage: this.pageConfig.pageSize,
        orderBy: 'createtime desc',
        whereCondition: JSON.stringify(this.pageConfig.queryParams)
      }).then(res => {
        this.pageConfig.tableData = res.data.queryResults || []
        this.pageConfig.total = res.data.totalCount
        this.pageConfig.loading = false
      }).catch(() => {
        this.pageConfig.loading = false
      })
    },

    /**
     * 查询表格数据
     */
    handleQuery () {
      this.pageConfig.pageNum = 1
      this.getTableData()
    },

    /**
     * 删除电站
     * @param row 电站数据
     */
    handleDelete (row) {
      this.$confirm(this.$t('notice.sc'), this.$t('notice.title'), {
        confirmButtonText: this.$t('button.qr'),
        cancelButtonText: this.$t('button.qx'),
        type: 'warning'
      }).then(() => {
        return DeleteStation({ id: row.id })
      }).then(() => {
        this.$message({
          type: 'success',
          message: this.$t('notice.sccg')
        })
        this.getTableData()
      })
    }
  }
}
</script>

<style scoped>
.top-view{
  width: 100%;
  box-sizing: border-box;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-gap: 20px;
}
.top-view>>>.el-card{
  background-color: #1d3666;
  border: none;
}
.top-view>>>.el-card__header{
  width: 100%;
  height: 40px;
  padding: 0 15px;
  box-sizing: border-box;
  font-size: 18px;
  color: #59c6ee;
  display: flex;
  align-items: center;
}
.top-view>>>.el-card__header>img{
  margin-right: 5px;
  height: 20px;
}
.top-view>>>.el-card__body{
  width: 100%;
  height: calc(100% - 40px);
  padding: 0;
  box-sizing: border-box;
  color: #b6801f;
  background-color: #1d3666;
  border: none;
}
.top-view>>>.el-card__body>.container{
  width: 100%;
  height: 100%;
  padding: 0;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
}
.top-view>>>.el-card__body>.container>#powerChart, #gatewayChart, #totalEnergyChart, #stationChart{
  width: 100%;
  height: 100%;
  padding: 0;
  box-sizing: border-box;
}

.filter-container{
  width: 100%;
  /* height: var(--filter-height); */
  padding: 0;
  box-sizing: border-box;
}
.filter-container>>>.el-form{
  width: 100%;
  height: 100%;
  padding: 0 20px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
}
.filter-container>>>.el-form-item{
  margin-bottom: 0;
}

.table-container{
  width: 100%;
  /* height: var(--table-height); */
  padding: 0;
  box-sizing: border-box;
  background-color: #1c2550;
}
.el-table__empty-block {
  background-color: #1d3666;
}
.el-table::before {
  background-color: #1d3666;
}

.pagination-container{
  width: 100%;
  height: 50px;
  padding: 0 15px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
</style>

